<div class="canvas">
  <db-builder-outline [outline]="outline"
                      [singlePage]="singlePage"
                      [pageMetas]="pageMetas"
                      (onGenerate)="onGenerate.emit()"
                      (openMagicLink)="openMagicLink.emit($event)"
                      [popupMode]="popupMode"
                      [isMobile]="isMobile"
                      [website]="website"
                      [tourStep]="tourStep"
                      [uniqueId]="uniqueId"
                      [disableDraggingEvents]="disableDraggingEvents"
                      [user]="user">
  </db-builder-outline>
</div>
<div *ngIf="!isMobile" [class.single-page]="singlePage"
     [class.active]="(startAnimations$|async) && !(builderInteractionsService.generatePrefilledSiteLoading | async) && (builderInteractionsService.discoverBusinessDataReady | async)"
     [class.hidden]="(builderInteractionsService.generatePrefilledSiteLoading | async) || !(builderInteractionsService.discoverBusinessDataReady | async)"
     [class.with-animation]="prefilledAi && !(builderInteractionsService.generatePrefilledSiteLoading | async) && (builderInteractionsService.discoverBusinessDataReady | async)">
  @if(prefilledAi && (builderInteractionsService.discoverBusinessDataReady | async)){
  <div  [class.with-animation]="prefilledAi"
     [class.visible]="(startAnimations$|async)">
   <db-site-info-sidebar (onEvent)="onEvent($event)" [website]="website">
    <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
  </db-site-info-sidebar>
  </div>
  }@else{
  <div class="db-first-half item">

    <i class="db-icon db-icon-ds-ai-generate fade-in-container mb8"></i>

    <div *ngIf="(builderInteractionsService.showSectionsLoading | async); else nonLoading" class="fade-in-container">
      <h1 class="mb18 fade-in">
        AI is creating your<br/>
  {{singlePage?'page': 'website' }} structure
        </h1>
        <h5 class="fade-in">
          Just a few seconds to complete.
        </h5>
      </div>

      <ng-template #nonLoading >
        <div class="fade-in-container">
          <h1 class="mb18 fade-in">
            Modify your site's<br/> structure
          </h1>
          <h5 class="fade-in">
            Help AI generate a personalized {{singlePage?'page': 'website' }}.
          </h5>
        </div>
      </ng-template>


      <div class="db-sitemap-steps">
        @for (step of sitemapStep; track step) {
  <span [class.dark]="singlePage"
        [ngClass]="{'ds-lazy-load': (builderInteractionsService.showSectionsLoading|async)}">{{ step }}</span>
  }
  </div>
</div>
<ng-container *ngTemplateOutlet="notificationContent"></ng-container>
  }

</div>
<ng-template #notificationContent>
  <div class="ds-notification-gray db-footer-text item"
       [class.full-width]="prefilledAi"
       *ngIf="!(builderInteractionsService.showSectionsLoading|async)">
    <div>
      <i class="db-icon db-icon-credentials"></i>
      <p>{{'text_youCanAlwaysCustomizeItLater' | dbText}}</p>
    </div>
  </div>
</ng-template>

